export default defineNuxtRouteMiddleware((to, from) => {
  const previousRoute = useState('previousRoute')

  if (import.meta.server) return

  const routeHistory = useState<any[]>('routeHistory', () => [])
  const lastHistoryPosition = useState<number | undefined>('lastHistoryPosition')
  const hookRegistered = useState('afterEachHookRegistered', () => false)

  if (!hookRegistered.value) {
    hookRegistered.value = true
    useRouter().afterEach(() => {
      lastHistoryPosition.value = window.history.state?.position
    })
  }

  const previousRouteList = [
    'boms',
    'expenses',
    'invoices',
    'orders',
    'requisitions',
    'requisitions-id',
    'projects',
    'projects-id',
    'projects-id-boms-bomId-index',
    'users',
  ]

  const skipPreviousRoute = useState('skipPreviousRoute', () => false)

  if (skipPreviousRoute.value) {
    skipPreviousRoute.value = false
    previousRoute.value = null
    return
  }

  if (!from || to.name === from.name || !previousRouteList.includes(from.name)) return

  const currentPosition = window.history.state?.position as number | undefined
  const isBack = currentPosition !== undefined
    && lastHistoryPosition.value !== undefined
    && currentPosition < lastHistoryPosition.value

  if (isBack) {
    routeHistory.value.pop()
    previousRoute.value = routeHistory.value.at(-1)
  }
  else {
    routeHistory.value.push(from)
    if (routeHistory.value.length > 50) {
      routeHistory.value.shift()
    }
    previousRoute.value = from
  }
})
